import yup, { string, object } from 'yup'
import { createFacilityAddressSchema } from './createFacilityAddressValidator'
import { facilityContactSchema } from './createFacilityContactValidator'
import { SchemaRules } from './schemaValidator'

const createFacilitySchema = {
  ...createFacilityAddressSchema,
  ...facilityContactSchema,
  id: string(),
  countryCode: string(),
  addressableId: string(),
}

const createFacilitySchemaObject = object(createFacilitySchema)

export type CreateFacilitySchema = Partial<yup.InferType<typeof createFacilitySchemaObject>>

const createFacilityValidator = new SchemaRules<CreateFacilitySchema>(createFacilitySchema)
export default createFacilityValidator
